import { Help } from '@/components/Form'
import { NumericInput } from '@/components/inputs/NumericInput'
import { TableCell } from '@/components/Table'
import { formatMoney } from '@/utils/money-util'
import styles from './MoneyCell.module.css'

export interface MoneyCellProps {
  editable: boolean
  children: number
  value: number | null
  onChange: (value: number | null) => void
  error?: string
  testId?: string
}

export function MoneyCell({
  editable,
  children,
  value,
  onChange,
  error,
  testId,
}: MoneyCellProps) {
  return (
    <TableCell>
      <div className={styles.money}>
        {editable ? (
          <>
            <div className={styles.moneyInput}>
              <NumericInput
                precision={2}
                value={value}
                onChange={onChange}
                testId={testId}
              />
            </div>
            <Help error={error} />
          </>
        ) : (
          formatMoney(children, true)
        )}
      </div>
    </TableCell>
  )
}
